import translations from './translations'

translations.add('pt', {
    yourKlarnaPaymentUnsuccessful: 'O seu pagamento Klarna falhou. Tente novamente mais tarde'
})
